//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TaggedObject.js";
let d=[[[0,"GohomePoint",1,"Point",0],[0,"GohomePointMode",1,0],[0,"GohomePointMotionType",1,0]],[],[]];
SPLM.CAM.TurnAvoidanceGohomeBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.TurnAvoidanceGohomeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.TurnAvoidanceGohomeBuilder.GohomePointMotionTypes = Object.freeze({
    "None" : "None", "Direct" : "Direct", "RadialThenAxial" : "RadialThenAxial", "AxialThenRadial" : "AxialThenRadial", "ClearRadialThenDirect" : "ClearRadialThenDirect", "ClearAxialThenDirect" : "ClearAxialThenDirect"});

SPLM.CAM.TurnAvoidanceGohomeBuilder.GohomePointModes = Object.freeze({
    "Point" : "Point", "SameAsFrom" : "SameAsFrom"});

export default SPLM;